import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

import locale_ru from './locale/ru.json'
import locale_en from './locale/en.json'
import locale_de from './locale/de.json'
import locale_es from './locale/es.json'
import locale_fr from './locale/fr.json'
import locale_it from './locale/it.json'
import locale_zh from './locale/zh.json'
import locale_uk from './locale/uk.json'

//если значение не задано, то показываем английское либо русское
for (var msg in locale_ru) {
  let val_ru=locale_ru[msg];
  let val=val_ru;
  if ( locale_en[msg]!=null && locale_en[msg].length>0 ) val=locale_en[msg];

  //если перевода нет или перевод = русскому значению, то ставим английский перевод либо русский
  if ( locale_en[msg]==null || locale_en[msg].length==0 || locale_en[msg]===val_ru ) locale_en[msg]=val;
  if ( locale_de[msg]==null || locale_de[msg].length==0 || locale_de[msg]===val_ru ) locale_de[msg]=val;
  if ( locale_es[msg]==null || locale_es[msg].length==0 || locale_es[msg]===val_ru ) locale_es[msg]=val;
  if ( locale_fr[msg]==null || locale_fr[msg].length==0 || locale_fr[msg]===val_ru ) locale_fr[msg]=val;
  if ( locale_it[msg]==null || locale_it[msg].length==0 || locale_it[msg]===val_ru ) locale_it[msg]=val;
  //@TODO когда появится словенский, то добавить его
  if ( locale_zh[msg]==null || locale_zh[msg].length==0 || locale_zh[msg]===val_ru ) locale_zh[msg]=val;
  if ( locale_uk[msg]==null || locale_uk[msg].length==0 ) locale_uk[msg]=val;
}

const messages = {
	RU: { message: locale_ru },
	EN: { message: locale_en },
	DE: { message: locale_de },
	ES: { message: locale_es },
	FR: { message: locale_fr },
	IT: { message: locale_it },
	SL: { message: locale_en }, //@TODO когда появится словенский, то использовать его
	ZH: { message: locale_zh },
  UK: { message: locale_uk }
};

var l = window._GL_CUR_LANG;

const defaultImpl = VueI18n.prototype.getChoiceIndex;
VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
	// this === VueI18n instance, so the locale property also exists here
	//alert(this.locale);
	if (this.locale !== 'RU') {
		// proceed to the default implementation
		return defaultImpl.apply(this, arguments)
	}

	if (choice === 0) {
		return 0;
	}

	const teen = choice > 10 && choice < 20;
	const endsWithOne = choice % 10 === 1;

	if (!teen && endsWithOne) {
		return 1;
	}

	if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
		return 2;
	}

	return (choicesLength < 4) ? 2 : 3;
};

export default new VueI18n({
		locale: l, // set locale
		messages, // set locale messages
});




//////////////////
// WEBPACK FOOTER
// ./src/i18n.js
// module id = null
// module chunks = 